import {
  LinkedinIcon_default
} from "./chunk-DF6HRKUN.mjs";
export {
  LinkedinIcon_default as default
};
